import { acceptOwnership, applyMintPriceChange, cancelMintPriceChange, closeMarket, ethToWei, openMarket, pauseMinting, scheduleMintPriceChange, setMarketFee, setDefaultBatchSize, setWhitelistBatchSize, setMaxRoyaltyBps, setRunnerAddress, setWallet, setWhitelisted, removeWhitelisted, transferOwnership, unpauseMinting, withdrawMarketFee, withdrawNFTFee, } from '../../chains/evm/api';
import { isEVMChain } from '../../wallet/chains';
function assertEvmChain(chain) {
    if (!isEVMChain(chain)) {
        throw new Error('EVM admin actions require an EVM network');
    }
}
async function withEvmAdminWallet(deps, fn) {
    assertEvmChain(deps.activeChain);
    if (!deps.evmSigner) {
        throw new Error('Please connect wallet to execute transaction!!!');
    }
    setWallet(deps.activeChain, deps.evmSigner);
    await fn();
    setRunnerAddress(deps.activeChain, deps.evmSigner.address);
    await deps.refreshEvmGlobalState();
}
export async function transferEvmOwnership(newOwner, deps) {
    await withEvmAdminWallet(deps, async () => {
        await transferOwnership(deps.activeChain, newOwner);
    });
    deps.toast.success('Ownership transfer initiated');
}
export async function acceptEvmOwnership(deps) {
    await withEvmAdminWallet(deps, async () => {
        await acceptOwnership(deps.activeChain);
    });
    deps.toast.success('Ownership accepted');
}
export async function openEvmMarket(deps) {
    await withEvmAdminWallet(deps, async () => {
        await openMarket(deps.activeChain);
    });
    deps.toast.success('Market opened');
}
export async function closeEvmMarket(deps) {
    await withEvmAdminWallet(deps, async () => {
        await closeMarket(deps.activeChain);
    });
    deps.toast.success('Market closed');
}
export async function scheduleEvmMintPriceChange(price, deps) {
    await withEvmAdminWallet(deps, async () => {
        await scheduleMintPriceChange(deps.activeChain, ethToWei(price));
    });
    deps.toast.success('Mint price change scheduled');
}
export async function applyEvmMintPriceChange(deps) {
    await withEvmAdminWallet(deps, async () => {
        await applyMintPriceChange(deps.activeChain, 0);
    });
    deps.toast.success('Mint price change applied');
}
export async function cancelEvmMintPriceChange(deps) {
    await withEvmAdminWallet(deps, async () => {
        await cancelMintPriceChange(deps.activeChain, 0);
    });
    deps.toast.success('Mint price change cancelled');
}
export async function setEvmMarketFee(fee, deps) {
    await withEvmAdminWallet(deps, async () => {
        await setMarketFee(deps.activeChain, fee);
    });
    deps.toast.success('Market fee updated');
}
export async function withdrawEvmMarketFee(deps) {
    await withEvmAdminWallet(deps, async () => {
        await withdrawMarketFee(deps.activeChain);
    });
    deps.toast.success('Market fee withdrawn');
}
export async function withdrawEvmNftFee(deps) {
    await withEvmAdminWallet(deps, async () => {
        await withdrawNFTFee(deps.activeChain);
    });
    deps.toast.success('Mint fee withdrawn');
}
export async function setEvmDefaultBatchSize(count, deps) {
    await withEvmAdminWallet(deps, async () => {
        await setDefaultBatchSize(deps.activeChain, count);
    });
    deps.toast.success('Default batch size updated');
}
export async function setEvmWhitelistBatchSize(count, deps) {
    await withEvmAdminWallet(deps, async () => {
        await setWhitelistBatchSize(deps.activeChain, count);
    });
    deps.toast.success('Whitelist batch size updated');
}
export async function setEvmMaxRoyaltyBps(bps, deps) {
    await withEvmAdminWallet(deps, async () => {
        await setMaxRoyaltyBps(deps.activeChain, bps);
    });
    deps.toast.success('Max royalty updated');
}
export async function pauseEvmMinting(deps) {
    await withEvmAdminWallet(deps, async () => {
        await pauseMinting(deps.activeChain);
    });
    deps.toast.success('Minting paused');
}
export async function unpauseEvmMinting(deps) {
    await withEvmAdminWallet(deps, async () => {
        await unpauseMinting(deps.activeChain);
    });
    deps.toast.success('Minting unpaused');
}
export async function setEvmWhitelisted(account, allowed, deps) {
    await withEvmAdminWallet(deps, async () => {
        if (allowed) {
            await setWhitelisted(deps.activeChain, account, true);
        }
        else {
            await removeWhitelisted(deps.activeChain, account);
        }
    });
    deps.toast.success(allowed ? 'Wallet added to whitelist' : 'Wallet removed from whitelist');
}
